import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { regenerateInvite } from "../api/client";
import { errorMessage } from "../lib/format";

export function Shell(props: { email: string; onLogout: () => void }) {
  const [note, setNote] = useState<string | null>(null);
  const invite = async () => {
    try {
      const { link } = await regenerateInvite();
      try {
        await navigator.clipboard.writeText(link);
        setNote("Invitation link copied.");
      } catch {
        // No clipboard (http, permissions): show it so it can be copied by hand.
        setNote(link);
      }
    } catch (e) {
      setNote(errorMessage(e));
    }
  };
  return (
    <>
      <header className="topbar">
        <span className="brand">golden</span>
        <nav>
          <NavLink to="/" end>
            Cards
          </NavLink>
          <NavLink to="/runs">Runs</NavLink>
          <NavLink to="/fetches">Fetches</NavLink>
          <NavLink to="/tokens">Tokens</NavLink>
        </nav>
        <span className="spacer" />
        {note && <span className="muted">{note}</span>}
        <button type="button" onClick={invite}>
          New invite link
        </button>
        <span className="email">{props.email}</span>
        <button type="button" onClick={props.onLogout}>
          Logout
        </button>
      </header>
      <main>
        <Outlet />
      </main>
    </>
  );
}
